import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthenticatedSession, useBalance } from '../../hooks';
import theme from '../../theme';
import { BalanceIcon, ProfileIcon, StatementIcon } from '../icons';
import { Nav, NavItem, IconWrapper, NotificationDot  } from './styles';

type Menu = 'statement' | 'profile' | 'balance';

const FloatingNavigationMenu: React.FC = () => {
    const location = useLocation();
    const { user } = useAuthenticatedSession();
    const { balances } = useBalance();

    const isHome = location.pathname === '/home';

    const getIconColor = useCallback((menu: Menu) =>
        location.pathname === `/${menu}` ? theme.primaryColor : theme.textDark, [location.pathname]);

    return (
        <Nav>
            <NavItem
                id="navmenu.statement"
                to="/statement"
                replace={!isHome}
            >
                <StatementIcon
                    iconColor={getIconColor('statement')}
                />
            </NavItem>
            <NavItem
                id="navmenu.profile"
                to="/profile"
                replace={!isHome}
            >
                <ProfileIcon
                    iconColor={getIconColor('profile')}
                />
            </NavItem>
            {user.hasBalancePermission && (
                <NavItem
                    id="navmenu.balance"
                    to="/balance"
                    replace={!isHome}
                >
                    <IconWrapper>
                        <BalanceIcon iconColor={getIconColor('balance')} />
                        {balances.length > 0 && <NotificationDot />}
                    </IconWrapper>
                </NavItem>
            )}
        </Nav>
    );
};

export { FloatingNavigationMenu };
